var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-image-banner"
  }, [_c('v-container', [_c('v-card', {
    staticClass: "py-30 px-20 border-radius-16 bg-right",
    attrs: {
      "flat": "",
      "img": _vm.item.image
    }
  }, [_c('v-row', {
    staticClass: "row--xxl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "388",
      "src": "/images/main/image-banner/banner-text.svg",
      "alt": ""
    }
  }, [_c('span', {
    staticClass: "d-sr-only"
  }, [_vm._v(" " + _vm._s(_vm.item.texts) + " ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/main/image-banner/banner-text-2.svg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mt-24",
    attrs: {
      "to": _vm.item.route,
      "large": "",
      "rounded": "pill",
      "color": "primary"
    }
  }, [_c('span', {
    staticClass: "page-text page-text--lg white--text"
  }, [_vm._v("더 알아보기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }